<template>
  <div class="m-case-text" :data-comp="blok.component" :class="[`--align-h-${blok.align_horizontal}`]">
    <div class="m-case-text__richtext">
      <sb-richtext :text="blok.text" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
});
</script>

<style lang="scss" scoped>
.m-case-text {
  --offset-y-base: 20vw;
  --width: v-bind(props.blok.width);
  --span: v-bind(props.blok.span);
  --offset-y: v-bind(props.blok.offset_y);

  flex: 0 1 calc(var(--span) / 12 * 100%);
  transform: translateY(calc(var(--offset-y) * var(--offset-y-base)));
  display: flex;
  justify-content: center;
  align-items: center;
  // outline: 1px solid blueviolet;

  @include global.breakpoint(tablet-portrait, max) {
    // slightly increase width on mobile
    --width: calc(min(v-bind(props.blok.width) + 0.15, 1));
  }

  &.--align-h {
    &-left {
      justify-content: flex-start;
    }
    &-right {
      justify-content: flex-end;
    }
  }

  &__richtext {
    width: calc(var(--width) * 100%);
  }
}
</style>
